import Search from "./Search.jsx";

export default Search;
